"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the index of the item in an array that is closest to the value
 * specified by the `needle` argument.
 */
exports.findClosestIndex = function (haystack, needle, filterMapFn) {
    var closest = {
        index: -1,
        distance: Number.POSITIVE_INFINITY,
        value: 0,
    };
    for (var index = 0; index < haystack.length; index++) {
        var rawValue = haystack[index];
        var value = rawValue;
        if (filterMapFn) {
            var mappedValue = filterMapFn(rawValue, index, haystack);
            switch (mappedValue) {
                case false:
                    continue;
                case true:
                    break;
                default:
                    value = mappedValue;
            }
        }
        // This statement should never be triggered in TypeScript if the overloaded
        // function signatures are correct. It's a little complex, so TS is not
        // certain that `value` is a number.
        if (typeof value !== 'number') {
            throw new TypeError("Expected a number value. Received " + value + ".");
        }
        var distance = Math.abs(value - needle);
        if (distance === 0) {
            return index;
        }
        if (distance < closest.distance) {
            closest = { index: index, distance: distance, value: value };
        }
    }
    return closest.index;
};
/**
 * Returns the item in an array that is closest to the value specified by the
 * `needle` argument.
 */
exports.findClosest = function (haystack, needle, filterMapFn) {
    return haystack[exports.findClosestIndex(haystack, needle, filterMapFn)];
};
exports.default = exports.findClosest;
//# sourceMappingURL=findClosest.js.map